<template>
  <header class="header">
    <div class="header-content">
      <h1 class="header-title">Realdaten</h1>
      <div v-if="isLoggedIn" class="user-actions">
        <img
          :src="userAvatar"
          alt="User Avatar"
          class="user-avatar"
        />
        <span>{{ user.username }}</span>
        <button class="logout-button" @click="handleLogout">Logout</button>
      </div>
    </div>
  </header>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      user: null // Benutzerinformationen werden hier gespeichert
    }
  },
  computed: {
    isLoggedIn () {
      return this.user !== null // Überprüft, ob ein Benutzer eingeloggt ist
    },
    userAvatar () {
      // Platzhalter-Bild verwenden, falls kein Avatar verfügbar ist
      return this.user?.avatar || '././public/img/avatar.jpg'
    }
  },
  methods: {
    async fetchUser () {
      try {
        const response = await axios.get('/api/getUser.php')
        if (response.data.success) {
          this.user = response.data.user // Benutzerinformationen setzen
        } else {
          console.error('Fehler beim Laden der Benutzerdaten:', response.data.error)
        }
      } catch (error) {
        console.error('API-Fehler beim Abrufen der Benutzerdaten:', error)
      }
    },
    async handleLogout () {
      try {
        // API-Call für Logout (optional)
        await axios.post('/api/logout.php')
      } catch (error) {
        console.error('Fehler beim Logout:', error)
      }

      // Benutzer zurücksetzen und weiterleiten
      this.user = null
      this.$router.push({ name: 'WelcomePage' })
    }
  },
  mounted () {
    this.fetchUser() // Benutzerdaten beim Laden der Komponente abrufen
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f3f5;
}

.header-title {
  font-size: 24px;
  font-weight: bold;
  color: #111418;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.logout-button {
  background-color: #007bff;
  color: #ffffff;
  border: none;
  padding: 5px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.logout-button:hover {
  background-color: #0056b3;
}
</style>
